import { Injectable } from '@angular/core';
import { AppConstants } from '../app-constants';
import * as CryptoJS from 'crypto-js';
//var CryptoJS = require('crypto-js');

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  constructor() {}

  encrypt(ciphertext: string) {
    return CryptoJS.AES.encrypt(ciphertext, AppConstants.cryptoKey);
  }

  decrypt(ciphertext: string) {
    console.log('ciphertext', ciphertext);
    var bytes = CryptoJS.AES.decrypt(
      ciphertext != undefined ? ciphertext.toString() : '',
      AppConstants.cryptoKey
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
